import { HttpErrorResponse } from "@angular/common/http";
import { ExternalInitialAssessment } from "src/app/_models/ExternalInitialAssessmentDto";

export interface ExternalInitialAssessmentState {
	externalInitAssessment: ExternalInitialAssessment;
	createExtInitAssessmentLoader: boolean;
	createExtInitAssessmentError: HttpErrorResponse;
	externalInitAssessmentResult: ExternalInitialAssessment;
}

export const initialExternalInitialAssessmentState: ExternalInitialAssessmentState = { 
	externalInitAssessment: null,
	createExtInitAssessmentLoader: false,
	createExtInitAssessmentError: null,
	externalInitAssessmentResult: null,
}